import Vue from 'vue'
import VueRouter from 'vue-router'
import urlConfig from '../config/urlConfig'
import localStorageUtil from '../utils/localStorageUtil'

Vue.use(VueRouter)

const routes = [
  {
    path: '/assemblePage',
    name: 'assemblePage',
    meta: {
      title: '超值拼团',
      requiresAuth: true
    },
    component: resolve =>
      require(['../components/assemble/assemblePage.vue'], resolve)
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    meta: {
      title: '商品详情',
      requiresAuth: true
    },
    component: resolve =>
      require(['../components/assemble/productDetail.vue'], resolve)
  },
  {
    path: '/myAssemble',
    name: 'myAssemble',
    meta: {
      title: '我的拼团',
      requiresAuth: true
    },
    component: resolve =>
      require(['../components/assemble/myAssemble.vue'], resolve)
  },
  {
    path: '/assembleDetail',
    name: 'assembleDetail',
    meta: {
      title: '拼团详情',
      requiresAuth: true
    },
    component: resolve =>
      require(['../components/assemble/assembleDetail.vue'], resolve)
  },
  {
    path: '/orderConfirm',
    name: 'orderConfirm',
    meta: {
      title: '拼团详情',
      requiresAuth: true
    },
    component: resolve =>
      require(['../components/assemble/orderConfirm.vue'], resolve)
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: '/assemble/',
  routes
})

// 路由拦截器
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let token = localStorageUtil.getCurrentUserToken()
  // 本地不拦
  if (window.location.hostname !== 'localhost') {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!token || token === null) {
        window.location.href = urlConfig.ssoUiUrl() + 'thirdParty/loginCompanyId?redirect=' + encodeURIComponent(urlConfig.localUrl() + to.fullPath)
        // next()
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router
